import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { SCHOOL_QUIZ_API_BASE_URL } from "../../components/config";
import {
  setState,
  setUpdateQuizForm,
  updateWinnerPrizeNew,
} from "../redux/slice";
import { updateQuiz } from "../redux/thunk";
import {
  fetchThemes,
  fetchSubjects,
  fetchSubjectBasedClassesData,
  fetchQuizTypes,
} from "../../components/SchoolQuiz/redux/schoolQuizSlice";
import ThemeSelector from "./ThemeSelector";
import { convertTermsToHtml } from "../utils";

export default function EditQuiz({ allotments, quizType }) {
  const { selectedQuiz, updateQuizForm, selectedSubThemes } = useSelector(
    (state) => state.quizManagement,
  );

  const { themes, quizTypesList, subjectsList, subjectBasedClasses } =
    useSelector((state) => state.schoolQuiz || {});

  const classes = subjectBasedClasses?.data || [];
  const subjects = subjectsList?.data || [];

  const [groups, setGroups] = useState([]);
  const [error, setError] = useState("");
  const fetchGroups = async () => {
    setError("");
    try {
      const res = await axios.get(`${SCHOOL_QUIZ_API_BASE_URL}/groups`);
      setGroups(Array.isArray(res.data) ? res.data : res.data?.data || []);
    } catch (err) {
      setError("Failed to fetch groups");
      console.error("fetchGroups error:", err);
    }
  };
  const dispatch = useDispatch();
  const {
    id,
    title,
    // start,
    registrationStart,
    registrationEnd,
    totalQuestions,
    questionDuration,
    correct,
    start,
    wrong,
    skipped,
    enableWrongMarks,
    enableSkippedMarks,
    registrationFeeMode,
    registrationCost,
    prizeDescription,
    about_quiz,
    quiz_terms,
    updated_by,
    // law_selected,
    description,
    // quizType,
    class_id,
    subject_id,
    subjectSpecificClasses,
  } = updateQuizForm;
  const data = selectedQuiz;
  const [group_id, setGroupId] = useState("");
  const [state, setStatee] = useState({
    allotments: allotments || [],
  });
  const [countInfo, setCountInfo] = useState(null);
  const userId = JSON.parse(localStorage.getItem("user"))?.id;

  useEffect(() => {
    dispatch(fetchSubjects());
    dispatch(fetchThemes());
    dispatch(fetchQuizTypes());

    fetchGroups();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);
  // console.log()
  // useEffect(() => {
  //   if (updateQuizForm.subject_id) {
  //     // ensure numeric id if your thunk expects it
  //     dispatch(fetchSubjectBasedClassesData(Number(updateQuizForm.subject_id)));
  //   }
  // }, [updateQuizForm.class_id, dispatch]);

  useEffect(() => {
    if (!updateQuizForm.subject_id) return;

    dispatch(
      fetchSubjectBasedClassesData({
        subject_id: Number(updateQuizForm.subject_id),
      }),
    )
      .unwrap()
      .then((res) => {
        console.log("subjectBasedClasses:", res); // check shape once, then remove
        dispatch(
          setUpdateQuizForm({
            key: "subjectSpecificClasses",
            value: res, // store whatever the thunk actually resolves to
          }),
        );
      })
      .catch(
        (err) => console.error("fetchSubjectBasedClassesData failed:", err),
        dispatch(
          setUpdateQuizForm({
            key: "subjectSpecificClasses",
            value: [], // store whatever the thunk actually resolves to
          }),
        ),
      );
  }, [updateQuizForm.subject_id, dispatch]);
  const formatToISTDatetimeLocal = (utcDateStr) => {
    if (!utcDateStr) return "";
    const date = new Date(utcDateStr);
    const istString = date.toLocaleString("en-IN", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });

    // Format returned like: "10/07/2025, 16:45"
    const [datePart, timePart] = istString.split(", ");
    const [day, month, year] = datePart.split("/");
    return `${year}-${month}-${day}T${timePart}`;
  };
  console.log("selected quiz", selectedQuiz);
  // 🟢 Replace your old "if (data)" useEffect with this version:
  useEffect(() => {
    // Wait until both data and classes have loaded
    if (data && classes.length > 0) {
      dispatch(
        setUpdateQuizForm({
          id: data.id || "",
          title: data.title || "jiii" || "",
          start: formatToISTDatetimeLocal(data.start_date),
          registrationStart: formatToISTDatetimeLocal(
            data.registration_start_date,
          ),
          registrationEnd: formatToISTDatetimeLocal(data.registration_end_date),
          totalQuestions: data.total_questions || "",
          questionDuration: data.duration_per_question || "",
          enableSkippedMarks: !!data.negative_marks_skipped,
          enableWrongMarks: !!data.negative_marks_wrong,
          correct: data.marks_per_question || "",
          registrationCost: data.registration_fee,
          registrationFeeMode: data.registration_fee > 0.0 ? "paid" : "free",
          wrong: data.negative_marks_wrong || "",
          skipped: data.negative_marks_skipped || "",
          winnerPrizes: Object.values(data.prizes || {}),
          topWinnersCount: Object.keys(data.prizes || {}).length,
          about_quiz: data.about_quiz,
          quiz_terms: data.quiz_terms,
          updated_by: userId,
          prizeDescription: data.prizes,
          description: data.description,
          class_id: String(data.class_id || ""),
          className: data.className || "",
          subject_id: String(data.subject_id || ""),
          themeData: data.themeDetails,
        }),
      );

      setGroupId(data?.group_id);
      setStatee((prev) => ({
        ...prev,
        allotments: data.difficulty_allotment,
      }));
    }
    // }, [data, classes.length, dispatch]);
  }, [data, dispatch]);

  function formatTerms(text) {
    if (!text) return "";

    const lines = text.split("\n").filter((l) => l.trim() !== "");

    let html = "<ol>";
    let inSubList = false;

    lines.forEach((line, idx) => {
      const trimmed = line.trim();

      // ✅ First line as heading (if it doesn’t start with a number.)
      if (idx === 0 && !/^\d+\./.test(trimmed)) {
        html = `<h3>${trimmed}</h3><ol>`;
        return;
      }

      // ✅ Main section (starts with number.)
      if (/^\d+\./.test(trimmed)) {
        if (inSubList) {
          html += "</ul>"; // close any open sublist
          inSubList = false;
        }
        // remove the leading number & dot
        const withoutNum = trimmed.replace(/^\d+\.\s*/, "");
        html += `<li><strong>${withoutNum}</strong><ul>`;
        inSubList = true;
      }
      // ✅ Sub-point
      else {
        if (inSubList) {
          html += `<li>${trimmed}</li>`;
        } else {
          html += `<p>${trimmed}</p>`;
        }
      }
    });

    if (inSubList) html += "</ul>";
    html += "</ol>";

    return html;
  }
  const handleChange = (key, value) => {
    dispatch(setUpdateQuizForm({ key, value }));

    // }
  };

  const handlePrizeChange = (index, value) => {
    dispatch(updateWinnerPrizeNew({ index, value }));
  };

  function handleAllotmentChange(difficulty_level) {
    if (
      !state.allotments.some(
        (item) => item.difficulty_level === difficulty_level,
      )
    ) {
      setStatee((prev) => ({
        ...prev,
        allotments: [...prev.allotments, { difficulty_level, percentage: "" }],
      }));
    }
  }

  const removeAllotment = (difficulty_level) => {
    setStatee((prev) => ({
      ...prev,
      allotments: prev.allotments.filter(
        (a) => a.difficulty_level !== difficulty_level,
      ),
    }));
  };
  function updatePercent(index, value) {
    setStatee((prev) => {
      const updated = prev.allotments.map((item, i) =>
        i === index ? { ...item, percentage: value } : item,
      );
      return { ...prev, allotments: updated };
    });
  }

  // const handleSubmit = async () => {
  //   const isLiveQuiz = quizType === 1 || quizType === 3;
  //   const isPracticeQuiz = quizType === 2 || quizType === 4;

  //   // const isThematicQuiz = quizType === 3 || quizType === "thematic";

  //   // getCount({
  //   //   class_ids: updateQuizForm.class_ids,
  //   //   theme_ids: updateQuizForm.theme_id
  //   //     ? selectedSubThemes?.length > 0
  //   //       ? selectedSubThemes.map(Number)
  //   //       : [Number(updateQuizForm.theme_id)]
  //   //     : [],
  //   //   // theme_ids: updateQuizForm.theme_ids,
  //   //   group_id: updateQuizForm.group_idd,
  //   //   subject_id: updateQuizForm.subject_id,
  //   // });
  //   // ✅ Step 1: Validate required details
  //   if (isLiveQuiz) {
  //     if (
  //       !registrationStart ||
  //       !registrationEnd ||
  //       !start ||
  //       !registrationFeeMode ||
  //       !subject_id ||
  //       !updateQuizForm.class_ids?.length ||
  //       state.allotments.length === 0
  //     ) {
  //       alert(
  //         "Missing required fields for Academic Live Quiz. Please include: start_date, registration_start_date, registration_end_date, registration_type, subject_id and class_ids.",
  //       );
  //       return; // ❗ Stop here → NO confirm popup, NO API call, popup stays open
  //     }
  //   }

  //   if (isPracticeQuiz) {
  //     if (!subject_id || !updateQuizForm.class_ids?.length) {
  //       alert("Please select subject and class for Practice Quiz.");
  //       return; // ❗ Stop here → popup stays open
  //     }
  //   }

  //   const isCommonValid =
  //     title?.trim() &&
  //     Number(totalQuestions) > 0 &&
  //     Number(questionDuration) > 0 &&
  //     about_quiz?.trim() &&
  //     quiz_terms?.trim() &&
  //     Array.isArray(state.allotments) &&
  //     state.allotments.length > 0;

  //   if (!isCommonValid) {
  //     alert("Please fill all required quiz details.");
  //     return;
  //   }

  //   // ✅ Step 2: Validate total question count
  //   // if (countInfo && Number(totalQuestions) > Number(countInfo?.total_count)) {
  //   //   alert(`Maximum number of questions allowed is ${countInfo.total_count}.`);
  //   //   return;
  //   // }

  //   // ✅ Step 3: Validate difficulty percentage (only for live/practice quizzes)
  //   const totalPercentage = (state.allotments || []).reduce(
  //     (sum, a) => sum + Number(a?.percentage || 0),
  //     0,
  //   );

  //   if (isLiveQuiz && totalPercentage !== 100) {
  //     alert("Total percentage of difficulty allotments must be exactly 100%.");
  //     return;
  //   }

  //   // ✅ Step 4: Validate dates for live quiz
  //   const now = Date.now();
  //   const regStart = Date.parse(registrationStart);
  //   const regEnd = Date.parse(registrationEnd);
  //   const startDate = Date.parse(start);

  //   if (isLiveQuiz) {
  //     if (regStart <= now) {
  //       alert("Registration start date must be in the future.");
  //       return;
  //     }
  //     if (regEnd <= regStart) {
  //       alert("Registration end date must be after registration start date.");
  //       return;
  //     }
  //     if (startDate <= regEnd) {
  //       alert("Quiz start date must be after registration end date.");
  //       return;
  //     }
  //   }

  //   // ✅ Step 5: Common request body
  //   const commonBody = {
  //     quiz_id: id,
  //     title,
  //     start_date: start,
  //     total_questions: Number(totalQuestions),
  //     duration_per_question: Number(questionDuration),
  //     marks_per_question: Number(correct),
  //     negative_marks_wrong: Number(wrong),
  //     negative_marks_skipped: Number(skipped),
  //     about_quiz,
  //     quiz_terms,
  //     quiz_type: quizType,
  //     updated_by,
  //     description,
  //   };

  //   // ✅ Step 6: Build quiz-type-specific payload
  //   const body = isLiveQuiz
  //     ? {
  //         ...commonBody,
  //         allotments: state.allotments.filter((a) => Number(a.percentage) > 0),
  //         registration_start_date: registrationStart,
  //         registration_end_date: registrationEnd,
  //         registration_fee:
  //           registrationFeeMode === "free"
  //             ? 0
  //             : parseFloat(registrationCost).toFixed(2),
  //         prizes: prizeDescription,
  //         registration_type: registrationFeeMode,
  //         ...(quizType === 1 || quizType === 2
  //           ? {
  //               subject_id: Number(subject_id),
  //               class_id: updateQuizForm.class_ids,
  //             }
  //           : quizType === 3 || quizType === 4
  //             ? {
  //                 group_id: updateQuizForm.group_idd,
  //                 theme_id:
  //                   selectedSubThemes && selectedSubThemes.length > 0
  //                     ? selectedSubThemes
  //                     : [updateQuizForm.themeId],
  //               }
  //             : {}),
  //       }
  //     : {
  //         ...commonBody, // fallback
  //       };

  //   console.log("🧾 Final Payload before confirmation:", body);

  //   // ✅ Step 7: Confirm and update
  //   if (!window.confirm("Are you sure you want to update this quiz?")) {
  //     console.log("❌ Update cancelled by user");
  //     return;
  //   }

  //   try {
  //     const res = await dispatch(updateQuiz(body));

  //     console.log("✅ API Response:", res);

  //     if (res?.payload?.message) {
  //       alert(res.payload.message);
  //     } else {
  //       alert("Quiz updated successfully!");
  //     }

  //     // ✅ Reset state after success
  //     setStatee({ allotments: [] });
  //     dispatch(setState({ key: "showPopup", value: false }));
  //     // window.location.reload();
  //     // dispatch(getQuizzes());
  //   } catch (err) {
  //     console.error("❌ Error updating quiz:", err);
  //     alert("Error updating quiz. Check console for details.");
  //   }
  // };

  const handleSubmit = async () => {
    // =========================================================
    // QUIZ TYPE FLAGS
    // =========================================================
    const isLiveQuiz = quizType === 1 || quizType === 3;
    const isPracticeQuiz = quizType === 2 || quizType === 4;

    const isAcademicQuiz = quizType === 1 || quizType === 2;
    const isThematicQuiz = quizType === 3 || quizType === 4;

    // =========================================================
    // COMMON VALIDATION
    // =========================================================
    const isCommonValid =
      title?.trim() &&
      Number(totalQuestions) > 0 &&
      Number(questionDuration) > 0 &&
      about_quiz?.trim() &&
      quiz_terms?.trim();

    if (!isCommonValid) {
      alert("Please fill all required quiz details.");
      return;
    }

    // =========================================================
    // ACADEMIC QUIZ VALIDATION
    // Quiz Type 1 - Live Academic
    // Quiz Type 2 - Practice Academic
    // =========================================================
    if (isAcademicQuiz) {
      if (!subject_id) {
        alert("Please select a subject.");
        return;
      }

      if (!updateQuizForm?.class_ids?.length) {
        alert("Please select at least one class.");
        return;
      }
    }

    // =========================================================
    // THEMATIC QUIZ VALIDATION
    // Quiz Type 3 - Live Thematic
    // Quiz Type 4 - Practice Thematic
    // =========================================================
    if (isThematicQuiz) {
      if (!updateQuizForm?.group_idd?.length) {
        alert("Please select at least one group.");
        return;
      }

      if (!updateQuizForm?.themeId) {
        alert("Please select a theme.");
        return;
      }
    }

    // =========================================================
    // LIVE QUIZ VALIDATION
    // Quiz Type 1 - Live Academic
    // Quiz Type 3 - Live Thematic
    // =========================================================
    if (isLiveQuiz) {
      if (
        !registrationStart ||
        !registrationEnd ||
        !start ||
        !registrationFeeMode
      ) {
        alert(
          "Please fill registration start date, registration end date, quiz start date and registration type.",
        );
        return;
      }

      // Validate allotments
      if (!Array.isArray(state?.allotments) || state.allotments.length === 0) {
        alert("Please add difficulty allotments.");
        return;
      }

      const totalPercentage = state.allotments.reduce(
        (sum, a) => sum + Number(a?.percentage || 0),
        0,
      );

      if (totalPercentage !== 100) {
        alert(
          "Total percentage of difficulty allotments must be exactly 100%.",
        );
        return;
      }

      // =======================================================
      // DATE VALIDATION
      // =======================================================
      const now = Date.now();

      const regStart = Date.parse(registrationStart);
      const regEnd = Date.parse(registrationEnd);
      const startDate = Date.parse(start);

      if (
        Number.isNaN(regStart) ||
        Number.isNaN(regEnd) ||
        Number.isNaN(startDate)
      ) {
        alert("Please provide valid registration and quiz dates.");
        return;
      }

      if (regStart <= now) {
        alert("Registration start date must be in the future.");
        return;
      }

      if (regEnd <= regStart) {
        alert("Registration end date must be after registration start date.");
        return;
      }

      if (startDate <= regEnd) {
        alert("Quiz start date must be after registration end date.");
        return;
      }
    }

    // =========================================================
    // COMMON PAYLOAD
    // =========================================================
    const commonBody = {
      quiz_id: id,
      title: title?.trim(),
      start_date: start,
      total_questions: Number(totalQuestions),
      duration_per_question: Number(questionDuration),
      marks_per_question: Number(correct),
      negative_marks_wrong: Number(wrong),
      negative_marks_skipped: Number(skipped),
      about_quiz,
      quiz_terms,
      quiz_type: quizType,
      updated_by,
      description,
    };

    // =========================================================
    // ACADEMIC / THEMATIC PAYLOAD
    // =========================================================
    let typeSpecificBody = {};

    // ---------------------------------------------------------
    // Academic
    // Type 1 - Live Academic
    // Type 2 - Practice Academic
    // ---------------------------------------------------------
    if (isAcademicQuiz) {
      typeSpecificBody = {
        subject_id: Number(subject_id),
        class_id: updateQuizForm.class_ids,
      };
    }

    // ---------------------------------------------------------
    // Thematic
    // Type 3 - Live Thematic
    // Type 4 - Practice Thematic
    // ---------------------------------------------------------
    if (isThematicQuiz) {
      typeSpecificBody = {
        group_id: updateQuizForm.group_idd,
        theme_id:
          selectedSubThemes?.length > 0
            ? selectedSubThemes
            : [updateQuizForm.themeId],
      };
    }

    // =========================================================
    // LIVE QUIZ PAYLOAD
    // =========================================================
    let liveBody = {};

    if (isLiveQuiz) {
      liveBody = {
        allotments: state.allotments.filter(
          (a) => Number(a?.percentage || 0) > 0,
        ),

        registration_start_date: registrationStart,

        registration_end_date: registrationEnd,

        registration_fee:
          registrationFeeMode === "free"
            ? 0
            : parseFloat(registrationCost || 0).toFixed(2),

        prizes: prizeDescription,

        registration_type: registrationFeeMode,
      };
    }

    // =========================================================
    // FINAL PAYLOAD
    // =========================================================
    const body = {
      ...commonBody,
      ...typeSpecificBody,
      ...liveBody,
    };

    console.log("====================================");
    console.log("Quiz Type:", quizType);
    console.log("Is Live Quiz:", isLiveQuiz);
    console.log("Is Practice Quiz:", isPracticeQuiz);
    console.log("Is Academic Quiz:", isAcademicQuiz);
    console.log("Is Thematic Quiz:", isThematicQuiz);
    console.log("====================================");
    console.log("🧾 Final Payload before confirmation:", body);

    // =========================================================
    // CONFIRMATION
    // =========================================================
    if (!window.confirm("Are you sure you want to update this quiz?")) {
      console.log("❌ Update cancelled by user");
      return;
    }

    // =========================================================
    // API CALL
    // =========================================================
    try {
      const res = await dispatch(updateQuiz(body));

      console.log("✅ API Response:", res);

      if (res?.payload?.message) {
        alert(res.payload.message);
      } else {
        alert("Quiz updated successfully!");
      }

      // Reset allotments
      setStatee({
        allotments: [],
      });

      // Close popup
      dispatch(
        setState({
          key: "showPopup",
          value: false,
        }),
      );
    } catch (err) {
      console.error("❌ Error updating quiz:", err);

      alert("Error updating quiz. Check console for details.");
    }
  };
  const getCount = async ({ class_ids, theme_ids, group_id, subject_id }) => {
    if (quizType) {
      const payload =
        quizType === 1 || quizType === 2
          ? {
              class_id: class_ids,
              subject_id,
            }
          : quizType === 3 || quizType === 4
            ? {
                theme_ids,
                group_id,
              }
            : {};
      try {
        // ✅ Use the actual API endpoint string (not the same variable name)
        const res = await axios.post(
          // "https://web1024.docmaster.in:5007/api/school/quiz/admin/get-count",
          "https://web1024.docmaster.in:5007/api/school/quiz/admin/get-count",
          {
            ...payload,
            quiz_type: quizType,
          },
        );

        console.log("✅ API Response:", res.data);
        setCountInfo(res.data || []);
        alert(`Available Questions Count: ${res.data.total_count}`);
        return res.data;
      } catch (err) {
        console.error("❌ getAvailableQuestionsCount error:", err);
        // rejectWithValue can only be used inside createAsyncThunk, so use throw here
        throw err.response?.data || err.message;
      }
    }
  };

  return (
    <div>
      <h2 className="mb-20" style={{ textAlign: "center", fontSize: "20px" }}>
        Edit Quiz ({quizTypesList?.data?.find((e) => e.id === quizType)?.type})
      </h2>
      <div style={{ marginBottom: "16px" }}>
        <label
          style={{ display: "block", fontWeight: "500", marginBottom: "4px" }}
        >
          Quiz Title
        </label>
        <input
          type="text"
          placeholder="Enter quiz title"
          value={title}
          onChange={(e) => handleChange("title", e.target.value)}
          required
          style={{
            width: "100%",
            padding: "8px 10px",
            borderRadius: "6px",
            border: "1px solid #ccc",
            fontSize: "14px",
          }}
        />
      </div>
      {/* Registration Section */}
      {(quizType === 1 || quizType === 3) && (
        <>
          <h3
            style={{
              textAlign: "center",
              fontSize: "18px",
              fontWeight: "600",
              marginBottom: "10px",
            }}
          >
            Registration Details
          </h3>

          <div style={{ display: "flex", gap: "5%", flexWrap: "wrap" }}>
            {[
              {
                label: "Registration Quiz Date",
                key: "registrationStart",
                value: registrationStart,
              },
              {
                label: "Registration End Date",
                key: "registrationEnd",
                value: registrationEnd,
              },
              { label: "Quiz Date", key: "start", value: start },
            ].map(({ label, key, value }) => (
              <div style={{ flex: "1 1 30%", marginBottom: "10px" }} key={key}>
                <label
                  style={{
                    display: "block",
                    fontWeight: "500",
                    marginBottom: "4px",
                  }}
                >
                  {label}
                </label>
                <input
                  type="datetime-local"
                  value={value}
                  onChange={(e) => handleChange(key, e.target.value)}
                  required
                  style={{
                    width: "100%",
                    padding: "8px 10px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    fontSize: "14px",
                  }}
                />
              </div>
            ))}
          </div>

          {/* Registration Fee Section */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "16px",
              marginTop: "16px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "24px" }}>
              <label style={{ fontWeight: "500" }}>Registration Fee</label>
              <div
                style={{ display: "flex", alignItems: "center", gap: "24px" }}
              >
                {["free", "paid"].map((mode) => (
                  <label
                    key={mode}
                    style={{ display: "inline-flex", alignItems: "center" }}
                  >
                    <input
                      type="radio"
                      name="registrationFeeMode"
                      value={mode}
                      checked={registrationFeeMode === mode}
                      onChange={(e) =>
                        handleChange("registrationFeeMode", e.target.value)
                      }
                      required
                      style={{ accentColor: "#2563eb" }}
                    />
                    <span
                      style={{ marginLeft: "8px", textTransform: "capitalize" }}
                    >
                      {mode}
                    </span>
                  </label>
                ))}
              </div>
            </div>

            {registrationFeeMode === "paid" && (
              <div
                style={{ display: "flex", alignItems: "center", gap: "10px" }}
              >
                <label style={{ fontWeight: "500" }}>Registration Cost</label>
                <input
                  type="number"
                  name="registrationCost"
                  value={registrationCost}
                  onChange={(e) =>
                    handleChange("registrationCost", e.target.value)
                  }
                  required
                  min="0"
                  style={{
                    width: "150px",
                    padding: "8px 10px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    fontSize: "14px",
                  }}
                />
              </div>
            )}
          </div>
        </>
      )}
      {/* Marks for Question Details */}
      <h3
        style={{
          textAlign: "center",
          fontSize: "18px",
          fontWeight: "600",
          marginTop: "16px",
          marginBottom: "10px",
        }}
      >
        Marks for Question Details
      </h3>
      <div style={{ display: "flex", gap: "5%", flexWrap: "wrap" }}>
        {[
          {
            label: "Total Question(s)",
            key: "totalQuestions",
            value: totalQuestions,
            type: "number",
          },
          {
            label: "Question Duration (in seconds)",
            key: "questionDuration",
            value: questionDuration,
            type: "number",
          },
        ].map(({ label, key, value, type }) => (
          <div style={{ flex: "1 1 30%", marginBottom: "10px" }} key={key}>
            <label
              style={{
                display: "block",
                fontWeight: "500",
                marginBottom: "4px",
              }}
            >
              {label}
            </label>
            <input
              type={type}
              value={value}
              min={1}
              onChange={(e) => handleChange(key, Number(e.target.value))}
              required
              style={{
                width: "100%",
                padding: "8px 10px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                fontSize: "14px",
              }}
            />
            {key === "totalQuestions" && countInfo && (
              <div>
                <p style={{ color: "red" }}>
                  Available Questions Count- {countInfo?.total_count}
                </p>
                <p>
                  {" "}
                  Level - question count
                  {JSON.stringify(countInfo.level_counts)}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
      <div style={{ display: "flex", gap: "5%", flexWrap: "wrap" }}>
        {/* Marks for Correct Answer */}
        <div style={{ flex: "1 1 30%", marginBottom: "10px" }}>
          <label
            style={{ display: "block", fontWeight: "500", marginBottom: "4px" }}
          >
            Marks For Correct Answer
          </label>
          <input
            type="number"
            value={correct}
            min="1"
            onChange={(e) => handleChange("correct", e.target.value)}
            required
            style={{
              width: "100%",
              padding: "8px 10px",
              borderRadius: "6px",
              border: "1px solid #ccc",
              fontSize: "14px",
            }}
          />
        </div>

        {/* Negative Marks for Wrong Answer */}
        <div style={{ flex: "1 1 30%", marginBottom: "10px" }}>
          <label
            style={{ display: "block", fontWeight: "500", marginBottom: "4px" }}
          >
            <input
              type="checkbox"
              checked={enableWrongMarks}
              onChange={(e) =>
                handleChange("enableWrongMarks", e.target.checked)
              }
            />{" "}
            Negative Marking For Wrong Answer
          </label>
          {enableWrongMarks && (
            <input
              type="number"
              placeholder="Marks for wrong answer"
              value={wrong}
              max="0"
              onChange={(e) => handleChange("wrong", e.target.value)}
              disabled={!enableWrongMarks}
              style={{
                width: "100%",
                padding: "8px 10px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                fontSize: "14px",
                marginTop: "6px",
              }}
            />
          )}
        </div>

        {/* Negative Marks for Skipped Answer */}
        <div style={{ flex: "1 1 30%", marginBottom: "10px" }}>
          <label
            style={{ display: "block", fontWeight: "500", marginBottom: "4px" }}
          >
            <input
              type="checkbox"
              checked={enableSkippedMarks}
              onChange={(e) =>
                handleChange("enableSkippedMarks", e.target.checked)
              }
            />{" "}
            Negative Marks For Skipped Answer
          </label>
          {enableSkippedMarks && (
            <input
              type="number"
              placeholder="Marks for skipped answer"
              value={skipped}
              max="0"
              onChange={(e) => handleChange("skipped", e.target.value)}
              disabled={!enableSkippedMarks}
              style={{
                width: "100%",
                padding: "8px 10px",
                borderRadius: "6px",
                border: "1px solid #ccc",
                fontSize: "14px",
                marginTop: "6px",
              }}
            />
          )}
        </div>
      </div>
      {(quizType === 3 || quizType === 4) && (
        <h3 style={{ textAlign: "center", fontSize: "18px" }}>
          Theme, Group Selection
        </h3>
      )}
      {(quizType === 3 || quizType === 4) && (
        <>
          <ThemeSelector themes={themes} themeData={updateQuizForm.themeData} />
          <div className="row" style={{ marginTop: "2%" }}>
            {" "}
            <label className="form-label" style={{ fontWeight: 545 }}>
              Groups
            </label>
            <div className="col-sm-9" style={{ display: "flex", gap: "2%" }}>
              {groups && groups.length > 0 ? (
                groups.map((g) => (
                  <label
                    key={g.group_id}
                    // className="flex items-center gap-2 mb-1"
                  >
                    {/* <input
                      type="checkbox"
                      value={g.group_id}
                      checked={updateQuizForm?.group_idd?.includes(g.group_id)}
                      onChange={(e) => {
                        const id = Number(e.target.value);
                        let updatedGroups;

                        if (e.target.checked) {
                          updatedGroups = [...updateQuizForm.groupIdd, id];
                        } else {
                          updatedGroups = updateQuizForm.groupIdd.filter(
                            (gid) => gid !== id,
                          );
                        }
                        dispatch(
                          setUpdateQuizForm({
                            key: "group_idd",
                            value: updatedGroups,
                          }),
                        );

                        // setGroupId(updatedGroups);
                      }}
                    /> */}
                    <input
                      type="checkbox"
                      value={g.group_id}
                      checked={updateQuizForm?.group_idd?.includes(g.group_id)}
                      onChange={(e) => {
                        const id = Number(e.target.value);

                        const currentGroups = updateQuizForm?.group_idd || [];

                        let updatedGroups;

                        if (e.target.checked) {
                          updatedGroups = [...currentGroups, id];
                        } else {
                          updatedGroups = currentGroups.filter(
                            (gid) => gid !== id,
                          );
                        }

                        dispatch(
                          setUpdateQuizForm({
                            key: "group_idd",
                            value: updatedGroups,
                          }),
                        );
                      }}
                    />
                    <span>{g.group_name}</span>
                  </label>
                ))
              ) : (
                <p>No groups available</p>
              )}
            </div>
            {/* <select
              className="form-control"
              value={group_idd || ""}
              // onChange={(e) => setGroupId(e.target.value)}
              onChange={(e) => handleChange("group_idd", e.target.value)}
            >
              <option value="">-- Select group --</option>
              {groups.map((c) => {
                const id = c.group_id;
                const label = c.group_name ?? c.group_name ?? c.group_name;
                return (
                  <option key={id} value={id}>
                    {label}
                  </option>
                );
              })}
            </select> */}
          </div>
        </>
      )}
      {/* question allotment */}
      {(quizType === 1 || quizType === 3) && (
        <>
          <div>
            <h3
              style={{
                textAlign: "center",
                fontSize: "20px",
                marginTop: "2%",
                fontWeight: 545,
              }}
            >
              Question Allotment Form
            </h3>
            {/* Difficulty Level Selector */}
            <div style={{ marginTop: "10px", marginBottom: "15px" }}>
              <label
                style={{
                  display: "block",
                  fontWeight: 545,
                  marginBottom: "6px",
                }}
              >
                Choose Difficulty Level(s)
              </label>
              <select
                style={{
                  width: "100%",
                  padding: "6px 10px",
                  border: "1px solid #bbb",
                  borderRadius: "6px",
                  fontSize: "0.95rem",
                }}
                onChange={(e) => handleAllotmentChange(e.target.value)}
                value=""
              >
                <option value="">Select</option>
                {["basic", "advanced", "ultra", "docmaster"].map((level) => (
                  <option key={level} value={level}>
                    {level}
                  </option>
                ))}
              </select>
            </div>
            {/* Total Display */}
            <div style={{ marginTop: "10px" }}>
              <strong>Total: </strong>
              <span
                style={{
                  color:
                    state.allotments.reduce(
                      (sum, a) => sum + Number(a.percentage || 0),
                      0,
                    ) === 100
                      ? "green"
                      : "red",
                }}
              >
                {state.allotments.reduce(
                  (sum, a) => sum + Number(a.percentage || 0),
                  0,
                )}
                %
              </span>{" "}
              (must be exactly 100%)
            </div>
            {/* Allotment List */}
            <div
              style={{
                marginLeft: "2%",
                display: "flex",
                flexWrap: "wrap",
                gap: "3rem",
                marginTop: "1%",
              }}
            >
              {state.allotments.map((each, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.5rem",
                    border: "1px solid #ccc",
                    padding: "6px 10px",
                    borderRadius: "6px",
                    width: "fit-content",
                    background: "#fafafa",
                  }}
                >
                  <p
                    style={{
                      margin: 0,
                      fontSize: "0.9rem",
                      fontWeight: 500,
                      textTransform: "capitalize",
                    }}
                  >
                    {{
                      easy: "Basic",
                      medium: "Advanced",
                      hard: "Ultra",
                      docmaster: "Docmaster",
                      basic: "Basic",
                      advanced: "Advanced",
                      ultra: "Ultra",
                    }[each.difficulty_level] || each.difficulty_level}
                  </p>

                  <input
                    type="number"
                    style={{
                      border: "1px solid #bbb",
                      borderRadius: "4px",
                      padding: "4px 6px",
                      width: "60px",
                      fontSize: "0.9rem",
                    }}
                    placeholder="0%"
                    value={each.percentage}
                    onChange={(e) =>
                      updatePercent(index, Number(e.target.value))
                    }
                  />

                  <button
                    type="button"
                    style={{
                      background: "transparent",
                      border: "none",
                      cursor: "pointer",
                      padding: 0,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    title="Remove"
                    onClick={() => removeAllotment(each.difficulty_level)}
                  >
                    <img
                      width="16"
                      height="16"
                      src="https://img.icons8.com/ios/50/delete-sign--v1.png"
                      alt="delete"
                    />
                  </button>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
      {(quizType === 1 || quizType === 3) && (
        <div className="mt-4">
          <h4 style={{ fontSize: "16px" }}>Winner Prize Details</h4>
          <textarea
            onChange={(e) => {
              console.log(e.target.value);
              handleChange("prizeDescription", e.target.value);
            }}
            value={prizeDescription}
            className="form-control"
            placeholder="Enter the winner price details..."
          />
        </div>
      )}
      {(quizType === 1 || quizType === 2) && (
        <>
          <h3 style={{ textAlign: "center", fontSize: "19px" }}>
            Subject and Class(es) selection
          </h3>
          <div className="form-group">
            <label className="form-label" style={{ fontWeight: 545 }}>
              Subject
            </label>
            <select
              className="form-control"
              value={subject_id || ""}
              // onChange={async (e) => {
              //   const newSubjectId = Number(e.target.value);

              //   // 🔥 RESET classes selection when subject changes
              //   dispatch(
              //     setUpdateQuizForm({
              //       key: "class_ids",
              //       value: [],
              //     }),
              //   );

              //   handleChange("subject_id", newSubjectId);
              //   const res = await dispatch(
              //     fetchSubjectBasedClassesData({ subject_id: newSubjectId }),
              //   ).unwrap();

              //   dispatch(
              //     setUpdateQuizForm({
              //       key: "subjectSpecificClasses",
              //       value: res,
              //     }),
              //   );
              // }}
              onChange={(e) => {
                const newSubjectId = Number(e.target.value);
                dispatch(setUpdateQuizForm({ key: "class_ids", value: [] }));
                handleChange("subject_id", newSubjectId);
              }}
              disabled={!class_id} // disable if no class selected
            >
              <option value="">-- Select Subject --</option>
              {subjects.map((s) => {
                const id = s.subject_id ?? s.id;
                const label =
                  s.subject_name ?? s.name ?? s.title ?? `Subject ${id}`;
                return (
                  <option key={id} value={id}>
                    {label}
                  </option>
                );
              })}
            </select>
          </div>
          <div style={{ marginBottom: "16px" }}>
            <label
              style={{
                display: "block",
                fontWeight: 545,
                marginBottom: "8px",
                fontSize: "14px",
              }}
            >
              Class
            </label>
            {subjectSpecificClasses?.length === 0 && (
              <p style={{ color: "red" }}>
                No classes found for the selected subject
              </p>
            )}
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: "10px 20px",
                width: "100%",
              }}
            >
              {(subjectSpecificClasses?.data || []).map((cls) => (
                <label
                  key={cls.class_id}
                  style={{
                    display: "inline-flex",
                    alignItems: "center",
                    gap: "6px",
                    margin: 0,
                    padding: "5px 10px",
                    cursor: updateQuizForm?.subject_id
                      ? "pointer"
                      : "not-allowed",
                    whiteSpace: "nowrap",
                  }}
                >
                  <input
                    type="checkbox"
                    name="class_ids"
                    value={cls.class_id}
                    checked={
                      Array.isArray(updateQuizForm?.class_ids) &&
                      updateQuizForm.class_ids.includes(cls.class_id)
                    }
                    onChange={(e) => {
                      const checked = e.target.checked;
                      const classId = cls.class_id;

                      const currentIds = Array.isArray(
                        updateQuizForm?.class_ids,
                      )
                        ? [...updateQuizForm.class_ids]
                        : [];

                      let updatedIds;

                      if (checked) {
                        updatedIds = [...currentIds, classId];
                      } else {
                        updatedIds = currentIds.filter((id) => id !== classId);
                      }

                      dispatch(
                        setUpdateQuizForm({
                          key: "class_ids",
                          value: updatedIds,
                        }),
                      );
                    }}
                    disabled={!updateQuizForm?.subject_id}
                    style={{
                      width: "16px",
                      height: "16px",
                      margin: 0,
                      cursor: updateQuizForm?.subject_id
                        ? "pointer"
                        : "not-allowed",
                    }}
                  />

                  <span
                    style={{
                      fontSize: "14px",
                      lineHeight: "20px",
                    }}
                  >
                    {cls.class_name}
                  </span>
                </label>
              ))}
            </div>
          </div>
        </>
      )}
      {/* {(quizType === 1 || quizType === 3) && (
        <>
          <div className="mt-4">
            <h4 style={{ fontSize: "16px" }}>Winner Prize Details</h4>
            <textarea
              onChange={(e) => {
                console.log(e.target.value);
                handleChange("prizeDescription", e.target.value);
              }}
              value={prizeDescription}
              className="form-control"
              placeholder="Enter the winner price details..."
            />
          </div>
        </>
      )} */}

      <h3 style={{ textAlign: "center", fontSize: "20px" }}>
        Terms and conditions
      </h3>
      <div className="form-group">
        <label className="form-label">About Quiz</label>
        <textarea
          className="form-input"
          value={about_quiz}
          onChange={(e) => handleChange("about_quiz", e.target.value)}
          required
        />
      </div>
      <div className="form-group">
        <label className="form-label">Terms and conditions</label>
        <textarea
          className="form-input"
          style={{ height: "60vh" }}
          value={quiz_terms}
          onChange={(e) => handleChange("quiz_terms", e.target.value)}
          required
        />
      </div>
      <div
        className="mt-4 p-3 border rounded bg-gray-50"
        style={{ height: "30vh", overflow: "auto" }}
      >
        <p>
          <strong>Note:</strong>
          Please ensure that the following variables are not removed from the
          Terms and Conditions section above.
        </p>
        <p>
          <strong>Variables used in the Terms and Conditions:</strong>
          <ol>
            <li>
              [Number] – Represents the total number of questions in the quiz.
            </li>
            <li>
              [X seconds] – Represents the total duration of the quiz,
              calculated as
              <em> total questions × duration per question (in seconds)</em>.
            </li>
            <li>
              [X second] – Represents the duration allocated for each question
              (in seconds).
            </li>
            <li>
              [Correct] – Represents the score awarded for each correct answer.
            </li>
          </ol>
        </p>
      </div>
      <div
        className="mt-4 p-3 border rounded bg-gray-50"
        style={{ height: "60vh", overflow: "auto" }}
      >
        <h4 className="mb-2 font-semibold" style={{ textAlign: "center" }}>
          Preview of Terms and Conditions
        </h4>
        {/* {(quizType === 2 || quizType === 4) && (
          <div
            dangerouslySetInnerHTML={{
              __html: formatTerms(quiz_terms),
            }}
          />
        )}
        {(quizType === 1 || quizType === 3) && (
          <div
            dangerouslySetInnerHTML={{
              __html: convertTermsToHtml(quiz_terms),
            }}
          />
        )} */}
        {/* <div
          dangerouslySetInnerHTML={{
            __html: formatTerms(quiz_terms),
          }}
        /> */}
        {quizType === 2 && (
          <div
            dangerouslySetInnerHTML={{
              __html: formatTerms(quiz_terms),
            }}
          />
        )}
        {(quizType === 1 || quizType === 3) && (
          <div
            dangerouslySetInnerHTML={{
              __html: convertTermsToHtml(quiz_terms),
            }}
          />
        )}
      </div>
      <button
        className="btn btn-primary w-full mt-20"
        onClick={(e) => {
          e.preventDefault();
          e.stopPropagation();
          handleSubmit();
          // getCount({
          //   class_ids: updateQuizForm.class_ids,
          //   theme_ids: updateQuizForm.theme_id
          //     ? selectedSubThemes?.length > 0
          //       ? selectedSubThemes.map(Number)
          //       : [Number(updateQuizForm.theme_id)]
          //     : [],
          //   // theme_ids: updateQuizForm.theme_ids,
          //   group_id: updateQuizForm.group_idd,
          //   subject_id: updateQuizForm.subject_id,
          // });
        }}
      >
        Update Quiz
      </button>
    </div>
  );
}

// const handleSubmit = async () => {
//   //console.log("update quiz form", updateQuizForm);
//   const isLiveQuiz = quizType === "live";
//   const isPracticeQuiz = quizType === "practice";
//   const isThematicQuiz = quizType === "thematic";
//   console.log("Selected Quiz Type:", quizType);

//   // ✅ Common validations
//   const isCommonValid =
//     title?.trim() &&
//     Number(totalQuestions) > 0 &&
//     Number(questionDuration) > 0 &&
//     about_quiz?.trim() &&
//     quiz_terms?.trim() &&
//     Array.isArray(state.allotments) &&
//     state.allotments.length > 0;

//   // ✅ Type-specific validations
//   const isPracticeValid =
//     isPracticeQuiz && selectedQuiz.quizType && isCommonValid;

//   const isLiveValid = isLiveQuiz && selectedQuiz.quizType && isCommonValid;

//   const isThematicValid = selectedQuiz.quizType && isCommonValid;
//   // ✅ Allotment percentage validation
//   if (
//     isLiveQuiz &&
//     (state.allotments || []).reduce(
//       (sum, a) => sum + Number(a?.percentage || 0),
//       0
//     ) !== 100
//   ) {
//     alert("Total percentage of difficulty allotments must be exactly 100%");
//     return;
//   }
//   if (
//     isPracticeQuiz &&
//     (state.allotments || []).reduce(
//       (sum, a) => sum + Number(a?.percentage || 0),
//       0
//     ) !== 100
//   ) {
//     alert("Total percentage of difficulty allotments must be exactly 100%");
//     return;
//   }

//   // ✅ Date validations
//   const now = Date.now();
//   const regStart = Date.parse(registrationStart);
//   const regEnd = Date.parse(registrationEnd);
//   const startDate = Date.parse(start);

//   if (isLiveQuiz) {
//     if (regStart <= now) {
//       alert("Registration start date must be in the future.");
//       return;
//     }
//     if (regEnd <= regStart) {
//       alert("Registration end date must be after registration start date.");
//       return;
//     }
//     if (startDate <= regEnd) {
//       alert("Start date of quiz must be after registration end date.");
//       return;
//     }
//   }

//   // ✅ Build request body
//   const commonBody = {
//     quiz_id: id,
//     title,
//     start_date: start,
//     total_questions: Number(totalQuestions),
//     duration_per_question: Number(questionDuration),
//     marks_per_question: Number(correct),
//     negative_marks_wrong: Number(wrong),
//     negative_marks_skipped: Number(skipped),
//     about_quiz,
//     quiz_terms,
//     quizType: selectedQuiz?.quizType,
//     updated_by,
//     description,
//   };

//   let body = {};

//   if (isLiveQuiz) {
//     body = {
//       ...commonBody,
//       allotments: state.allotments.filter((a) => Number(a.percentage) > 0),
//       registration_start_date: registrationStart,
//       registration_end_date: registrationEnd,
//       registration_fee: parseFloat(registrationCost).toFixed(2),
//       prizes: prizeDescription,
//       subject_id: Number(subject_id),
//       class_id: Number(class_id),
//       // winnerPrizes.reduce((acc, val, idx) => {
//       //   acc[(idx + 1).toString()] = parseFloat(val).toFixed(2);
//       //   return acc;
//       // }, {}),
//       registration_type: registrationFeeMode,
//     };
//   }
//   if (quizType === "thematic") {
//     body = {
//       ...commonBody,
//       allotments: state.allotments.filter((a) => Number(a.percentage) > 0),
//       registration_start_date: registrationStart,
//       registration_end_date: registrationEnd,
//       registration_fee: parseFloat(registrationCost).toFixed(2),
//       prizes: prizeDescription,
//       subject_id: Number(subject_id),
//       class_id: Number(class_id),
//       // winnerPrizes.reduce((acc, val, idx) => {
//       //   acc[(idx + 1).toString()] = parseFloat(val).toFixed(2);
//       //   return acc;
//       // }, {}),
//       registration_type: registrationFeeMode,
//       group_id,
//       theme_id: selectedSubThemes
//         ? selectedSubThemes
//         : [updateQuizForm.themeId],
//     };
//   }

//   if (isPracticeQuiz) {
//     body = {
//       ...commonBody,
//       allotments: state.allotments.filter((a) => Number(a.percentage) > 0),
//       subject_id: Number(subject_id),
//       class_id: Number(class_id),
//     };
//   }

//   console.log("Final Payload:", body);
//   //  const selectedTheme = selectedSubThemes
//   // ? selectedSubThemes
//   // : [updateQuizForm.themeId];
//   if (window.confirm("Are you sure to update quiz")) {
//     try {
//       // await axios.post("/admin/create-quiz", body);
//       // debugger;
//       const res = await dispatch(updateQuiz(body));
//       if (res) {
//         console.log(res);
//         alert(res?.payload?.message || "Quiz updated");
//         setStatee({
//           allotments: [],
//         });
//         dispatch(
//           setState({
//             key: "showPopup",
//             value: false,
//           })
//         );
//         dispatch(getQuizzes());
//       }
//     } catch (err) {
//       console.error("Error details:", err);
//       alert("Error creating quiz");
//     }
//   }
// };

// const getThemeSelectionState = (themes, selectedIds) => {
//   return themes.map((theme) => {
//     const subThemes = theme.sub_theme || [];

//     // Determine if any subthemes are selected
//     const checkedSubThemes = subThemes.filter((sub) =>
//       selectedIds.includes(sub.theme_id)
//     );

//     // Parent should be considered selected only if any subthemes are selected
//     const isParentSelected = checkedSubThemes.length > 0;

//     return {
//       ...theme,
//       isParentSelected,
//       sub_theme: subThemes.map((sub) => ({
//         ...sub,
//         checked: selectedIds.includes(sub.theme_id),
//       })),
//     };
//   });
// };
// const themeSelectionState =
//   quizType === "thematic" &&
//   getThemeSelectionState(themes, selectedQuiz.theme_id);
// const themeData1 = [{ theme_id: 1, sub_themes: [] }];
